import React from 'react';

const HtmlContent = ({ html }) => {
  return <div 
  style={{ display: 'inline-block' }}
  dangerouslySetInnerHTML={{ __html: html }} />;
};

export default HtmlContent;
